import { isMethodAvailableOnDevice } from "./isMethodAvailableOnDevice"

// Filtert eine Mollie-Methodenliste auf die geraeteseitig tatsaechlich nutzbaren Methoden
// (Apple Pay nur auf Apple-Geraeten/Safari). EINE Quelle fuer BookingSummary (Count →
// Mandatory/Combined-Mode + Submit-Button) und SummaryRight/MollieMethodsBlock (Liste),
// damit die drei Stellen nicht auseinanderdriften (sonst bleibt der Submit-Button bei
// einem Wallet-only-Kurs auf Nicht-Apple-Geraeten haengen, obwohl SummaryRight korrekt
// auf die klassische Zahlarten-Tabelle zurueckfaellt).
export function gateMollieMethodsForDevice<T extends { id: string }>(
    methods: ReadonlyArray<T> | null | undefined,
): T[] {
    if (!methods) return []
    return methods.filter((m) => isMethodAvailableOnDevice(m.id))
}
